import { memo } from "react";
import { ConversionAccessProvider } from "../conversion/context/conversion-access";
import { EcommerceProvidersContextProvider } from "./ecommerce-providers";
import { MerchantRoutesProvider } from "./merchant-routes";

export const ProductSuiteProvider = memo(function ProductSuiteProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <EcommerceProvidersContextProvider>
      <ConversionAccessProvider>
        <MerchantRoutesProvider>{children}</MerchantRoutesProvider>
      </ConversionAccessProvider>
    </EcommerceProvidersContextProvider>
  );
});
